export type MarketCode = 'AU' | 'US' | 'GB'

export interface MarketConfig {
  code: MarketCode
  label: string
  flag: string
  locale: string
  dateFormat: string
  dayjsLocale: string
  companyInfo: {
    registrationId: string
    companyName: string
    jurisdiction: string
  }
  shipping: {
    domesticDays: string
    internationalDays: string
    domesticLabel: string
  }
  spelling: {
    personalised: string
    colour: string
  }
}

export const MARKET_CONFIGS: Record<MarketCode, MarketConfig> = {
  AU: {
    code: 'AU',
    label: 'Australia',
    flag: '\u{1F1E6}\u{1F1FA}',
    locale: 'en-AU',
    dateFormat: 'DD/MM/YYYY',
    dayjsLocale: 'en-au',
    companyInfo: {
      registrationId: 'ABN 58 692 683 720',
      companyName: 'Pixie Education Pty Ltd',
      jurisdiction: 'Australia',
    },
    shipping: {
      domesticDays: '5\u20137 business days',
      internationalDays: '10\u201315 business days',
      domesticLabel: 'Australian orders',
    },
    spelling: {
      personalised: 'personalised',
      colour: 'colour',
    },
  },
  US: {
    code: 'US',
    label: 'United States',
    flag: '\u{1F1FA}\u{1F1F8}',
    locale: 'en-US',
    dateFormat: 'MM/DD/YYYY',
    dayjsLocale: 'en',
    companyInfo: {
      registrationId: '',
      companyName: 'Pixie Education Pty Ltd',
      jurisdiction: 'the State of Delaware, United States',
    },
    shipping: {
      domesticDays: '7\u201310 business days',
      internationalDays: '10\u201315 business days',
      domesticLabel: 'US orders',
    },
    spelling: {
      personalised: 'personalized',
      colour: 'color',
    },
  },
  GB: {
    code: 'GB',
    label: 'United Kingdom',
    flag: '\u{1F1EC}\u{1F1E7}',
    locale: 'en-GB',
    dateFormat: 'DD/MM/YYYY',
    dayjsLocale: 'en-gb',
    companyInfo: {
      registrationId: '',
      companyName: 'Pixie Education Pty Ltd',
      jurisdiction: 'England and Wales',
    },
    shipping: {
      domesticDays: '7\u201310 business days',
      internationalDays: '10\u201315 business days',
      domesticLabel: 'UK orders',
    },
    spelling: {
      personalised: 'personalised',
      colour: 'colour',
    },
  },
}

export const DEFAULT_MARKET: MarketCode = 'AU'

export const MARKET_CODES = Object.keys(MARKET_CONFIGS) as MarketCode[]
